export type EmailAutomationStatus = "Draft" | "Active" | "Paused";

export interface EmailAutomationRow {
  key: string;
  name: string;
  status: EmailAutomationStatus;
  /** API trigger — used for row actions (e.g. duplicate limits) without paging lookups. */
  trigger: EmailAutomationApiItem["trigger"];
  offerings: number;
  sent: number;
  delivered: number;
}

export interface EmailAutomationApiItem {
  id: number;
  automationName: string;
  subject: {
    variables: string[];
    template: string;
  };
  body: {
    variables: string[];
    template: string;
  };
  userId: number;
  trigger: "after-purchase" | "abandoned-purchase";
  customButton: boolean;
  draft: boolean;
  /** When true and not draft, automation is paused (no sends). */
  isPaused?: boolean;
  buttonText: string;
  buttonLink: string;
  createdAt: string;
  updatedAt: string;
  analytics?: {
    sent: number;
    delivered: number;
  } | null;
  settings: {
    id: number;
    sendTime: "immediate" | "custom";
    delayTime: number;
    pivot: {
      id: number;
      offeringId: number;
      offeringName: string;
      createdAt: string;
    }[];
    createdAt: string;
    updatedAt: string;
  } | null;
}

export function normalizeEmailAutomation(
  item: EmailAutomationApiItem
): EmailAutomationRow {
  let status: EmailAutomationStatus = "Active";
  if (item.draft) {
    status = "Draft";
  } else if (item.isPaused) {
    status = "Paused";
  }

  return {
    key: String(item.id),
    name: item.automationName,
    status,
    trigger: item.trigger,
    offerings: item.settings?.pivot?.length ?? 0,
    sent: item.analytics?.sent ?? 0,
    delivered: item.analytics?.delivered ?? 0,
  };
}
